module.exports = __webpack_public_path__ + "static/img/cabecera.5977a7b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/info-en/cabecera.jpg
// module id = YuRK
// module chunks = 0